export default class StatisticsModal {
  constructor(args) {
    this.statisticData = args.statisticData;
    this.modal = args.modal;

    if(!this.modal.element) return;
    this.buttonShowModal = document.querySelectorAll('.button-show-statistics-modal');

    if(this.statisticData) this.initChart();
    this.addEvents();
  }

  initChart() {
    nv.addGraph(() => {
      const jsonObj = JSON.parse(phpObj);
      this.chart = nv.models.multiBarChart().showControls(false);

      this.chart.xAxis.tickFormat((d) => d3.time.format('%d.%m.%Y')(new Date(d)));

      d3.select('#chart_div').append('svg')
        .datum(jsonObj)
        .transition().duration(500)
        .call(this.chart);

        nv.utils.windowResize(this.chart.update);

      return this.chart;
    });
  }

  addEvents() {
    [...this.buttonShowModal].map(button => {
      button.addEventListener('click', e => {
        this.modal.open();
        if(this.statisticData) this.chart.update();
      });
    });
  }
}